import axios from 'axios'
import store from '@/store'

export default axios.create({
  baseURL: 'https://integrations-v2.sodlab.com/api/notaria/tramites-b2c/',
  transformRequest: [function (data, headers) {
    headers.Authorization = store.state.user.signInUserSession.idToken.jwtToken
    return JSON.stringify(data)
  }]
})
